<template>
  <div class="w-full buildrscf">
    <el-dialog
      :visible.sync="isshowscope"
      width="75%"
      :before-close="handleClose2"
    >
      <template slot="title">
        <h3 class="text-white text-lg">Scope Requirements</h3>
      </template>
      <div>
        <Newscope
          :isshowscope="this.isshowscope"
          @closePopupFunc="closePopupFunc"
          :tabForReq="this.tabForReq"
        />
      </div>
    </el-dialog>

    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div class="">
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Scope new Requirements
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white menucontrol-scroll fixed-top mx-auto p-8">
      <!-- <el-dialog
        title="Add"
        :visible.sync="isShowAdd"
        width="35%"
        :before-close="handleClose"
      >
        <el-input v-model="add" placeholder="Add page name" />

        <div class="mt-6">
          <p class="font-semibold fsize16">AI Recommendations</p>

          <el-input
            class="mt-2"
            type="textarea"
            disabled
            v-model="add"
            placeholder="Add your thoughts..."
          />
          <div class="grid grid-cols-4 gap-2 mt-4">
            <p
              class="fsize12 font-medium sm-fsize12 px-6 py-2 text-warning rounded-full text-center light-chipswarning"
            >
              Home
            </p>

            <p
              class="fsize12 font-medium sm-fsize12 px-6 py-2 text-warning rounded-full text-center light-chipswarning"
            >
              About Us
            </p>
            <p
              class="fsize12 font-medium sm-fsize12 px-6 py-2 text-warning rounded-full text-center light-chipswarning"
            >
              Contact Us
            </p>
            <p
              class="fsize12 font-medium sm-fsize12 px-6 py-2 text-warning rounded-full text-center light-chipswarning"
            >
              Register
            </p>
          </div>
        </div>

        <div class="mt-10 flex justify-center gap-4">
          <vs-button
            variant="primary"
            class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Confirm
          </vs-button>

          <vs-button
            color="secondary"
            class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Cancel
          </vs-button>
        </div>
      </el-dialog> -->
      <!-- role -->
      <el-dialog
        title="Add Role"
        :visible.sync="isShowAddForRoles"
        width="35%"
        :before-close="handleClose"
      >
        <!-- <el-form
          role="form"
          class=""
          :model="ruleFormRoles"
          :rules="rules"
          ref="ruleFormRoles"
        >
          <el-form-item prop="addRole"> -->
        <el-input
          v-model="addRole"
          placeholder="Add Role,Role1,Role2,...... avoid spaces"
          data-vv-validate-on="input|blur"
          v-validate="'required'"
          name="Role"
        />
        <p v-if="errors.has('Role')" class="text-danger">
          {{ errors.first("Role") }}
        </p>
        <!-- </el-form-item> -->
        <div class="mt-6">
          <p class="font-semibold fsize16">AI Recommendations</p>

          <el-input
            class="mt-2"
            type="textarea"
            disabled
            :rows="this.addMultipleRole.length"
            v-model="addMultipleRole"
            placeholder="Selected recommendations..."
          />
          <div class="gap-2 flex flex-wrap">
            <div
              class="mt-4"
              v-for="(i, index) in this.rolesRecommends"
              :key="index"
            >
              <p
                :class="
                  addMultipleRole.includes(i)
                    ? 'fsize12 flex items-center font-medium sm-fsize12 text-center light-primary-lights text-primary cursor-pointer '
                    : 'fsize12 flex items-center font-medium sm-fsize12 text-center light-chipsgrey cursor-pointer'
                "
                @click="addRoleFromRecommends(i)"
              >
                {{ i }}
              </p>
            </div>
          </div>
        </div>
        <!-- @click="
                !addRole.length ? handleSubmit('ruleFormRoles') : addLogsData()
              " -->
        <div class="mt-10 flex justify-center gap-4">
          <vs-button
            variant="primary"
            :disabled="!addRole.length && !addMultipleRole.length"
            @click="addLogsData()"
            class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Confirm
          </vs-button>

          <vs-button
            color="secondary"
            @click="resetFunc()"
            class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Reset
          </vs-button>
        </div>
        <!-- </el-form> -->
      </el-dialog>
      <!-- page -->
      <el-dialog
        title="Add Website Pages"
        :visible.sync="isShowAddForPages"
        width="35%"
        :before-close="handleClose"
      >
        <el-form
          role="form"
          class=""
          :model="ruleFormWebPg"
          :rules="rules"
          ref="ruleFormWebPg"
        >
          <el-form-item prop="addPage">
            <el-input
              v-model="ruleFormWebPg.addPage"
              placeholder="Add Page,Page1,Page2,...... avoid spaces"
              data-vv-validate-on="input|blur"
              v-validate="'required'"
            />
            <!--  v-validate="'required'"
              name="Website Page" -->
            <!-- <p v-if="errors.has('Website Page')" class="text-danger">
          {{ errors.first("Website Page") }}
        </p> -->
          </el-form-item>
          <div class="mt-6">
            <p class="font-semibold fsize16">AI Recommendations</p>

            <el-input
              class="mt-2"
              type="textarea"
              disabled
              :rows="this.addMultiplePage.length"
              v-model="addMultiplePage"
              placeholder="Selected recommendations..."
            />
            <div class="mt-4 gap-2 flex flex-wrap">
              <div
                class=""
                v-for="(i, index) in this.pagesRecommends"
                :key="index"
              >
                <p
                  :class="
                    addMultiplePage.includes(i)
                      ? 'fsize12 flex items-center font-medium sm-fsize12 text-center light-chipswarning cursor-pointer'
                      : 'fsize12 flex items-center font-medium sm-fsize12 text-center light-chipsgrey cursor-pointer'
                  "
                  @click="addPageFromRecommends(i)"
                >
                  {{ i }}
                </p>
              </div>
            </div>
          </div>
          <!-- @click="
              ruleFormWebPg.addPage != ''
                ? handleSubmit('ruleFormWebPg')
                : addLogsData()
            " -->
          <!--  @click="addLogsData()" -->
          <div class="mt-10 flex justify-center gap-4">
            <vs-button
              variant="primary"
              :disabled="
                !ruleFormWebPg.addPage.length && !addMultiplePage.length
              "
              @click="
                !ruleFormWebPg.addPage.length
                  ? handleSubmit('ruleFormWebPg')
                  : addLogsData()
              "
              class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Confirm
            </vs-button>

            <vs-button
              color="secondary"
              @click="resetFunc"
              class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Reset
            </vs-button>
          </div>
        </el-form>
      </el-dialog>
      <!-- Admin Page -->
      <el-dialog
        title="Add Admin Pages"
        :visible.sync="isShowAddForAdminPages"
        width="35%"
        :before-close="handleClose"
      >
        <el-form
          role="form"
          class=""
          :model="ruleFormAdPg"
          :rules="rules"
          ref="ruleFormAdPg"
        >
          <el-form-item prop="addAdminPage">
            <el-input
              v-model="ruleFormAdPg.addAdminPage"
              placeholder="Add Page,Page1,Page2,...... avoid spaces"
              data-vv-validate-on="input|blur"
              v-validate="'required'"
            />
            <!--  v-validate="'required'"
              name="Admin Page" -->
            <!-- <p v-if="errors.has('Admin Page')" class="text-danger">
          {{ errors.first("Admin Page") }}
        </p> -->
          </el-form-item>
          <div class="mt-6">
            <p class="font-semibold fsize16">AI Recommendations</p>

            <el-input
              class="mt-2"
              type="textarea"
              disabled
              :rows="this.addMultipleAdminPage.length"
              v-model="addMultipleAdminPage"
              placeholder="Selected recommendations..."
            />
            <div class="mt-4 gap-2 flex flex-wrap">
              <div
                class=""
                v-for="(i, index) in this.pagesRecommends"
                :key="index"
              >
                <p
                  :class="
                    addMultipleAdminPage.includes(i)
                      ? 'fsize12 flex items-center font-medium sm-fsize12 text-center light-chipswarning cursor-pointer'
                      : 'fsize12 flex items-center font-medium sm-fsize12 text-center light-chipsgrey cursor-pointer'
                  "
                  @click="addAdminPageFromRecommends(i)"
                >
                  {{ i }}
                </p>
              </div>
            </div>
          </div>
          <!--@click="
              ruleFormAdPg.addAdminPage != ''
                ? handleSubmit('ruleFormAdPg')
                : addLogsData()
            "  -->
          <div class="mt-10 flex justify-center gap-4">
            <vs-button
              :disabled="
                !ruleFormAdPg.addAdminPage.length &&
                !addMultipleAdminPage.length
              "
              variant="primary"
              @click="
                !ruleFormAdPg.addAdminPage.length
                  ? handleSubmit('ruleFormAdPg')
                  : addLogsData()
              "
              class="rounded-full border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Confirm
            </vs-button>

            <vs-button
              color="secondary"
              @click="resetFunc"
              class="rounded-full bg-secondary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
            >
              Reset
            </vs-button>
          </div>
        </el-form>
      </el-dialog>
      <!-- User Stories -->
      <el-dialog
        :visible.sync="isShowUserAdd"
        width="45%"
        title="Add User Stories"
        :before-close="handleClose"
      >
        <!-- <el-form
          role="form"
          class=""
          :model="ruleFormStories"
          :rules="rules"
          ref="ruleFormStories"
        >
          <el-form-item prop="addUserStoriesValue"> -->
        <div class="" v-for="(i, index) in addUserStoriesValue" :key="index">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <h2 class="fsize14 font-semibold mb-2">As a</h2>
              <el-select
                v-model="i['As a']"
                collapse-tags
                v-validate="'required'"
                placeholder="Select"
                class="fsize14"
                name="Role"
              >
                <el-option
                  v-for="item in roleForStories"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <p v-if="errors.has('Role')" class="text-danger">
                {{ errors.first("Role") }}
              </p>
            </div>

            <div>
              <h2 class="fsize14 font-semibold mb-2">On</h2>
              <el-select
                v-model="i.On"
                collapse-tags
                v-validate="'required'"
                placeholder="Select"
                class="fsize14"
                name="Page"
              >
                <el-option
                  v-for="item in pageForStories"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
              <p v-if="errors.has('Page')" class="text-danger">
                {{ errors.first("Page") }}
              </p>
            </div>
          </div>
          <div class="mt-8">
            <h2 class="fsize14 font-semibold mb-2">Description</h2>
            <el-input
              type="textarea"
              :rows="2"
              placeholder="Please input"
              class="fsize14 w-full"
              v-model="i.Description"
              v-validate="'required'"
              name="Description"
            >
            </el-input>
            <p v-if="errors.has('Description')" class="text-danger">
              {{ errors.first("Description") }}
            </p>
          </div>
        </div>
        <!-- </el-form-item> -->
        <p
          @click="addDesp()"
          class="text-primary fsize12 font-semibold flex items-center mt-2 cursor-pointer"
        >
          <feather-icon
            icon="PlusIcon"
            class="mini-tops"
            svgClasses="w-4 h-4"
          />
          Add
        </p>

        <div class="flex gap-4 justify-center mt-10 pb-7">
          <vs-button
            @click="addStoriesFunc()"
            class="font-semibold rounded-full lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
          >
            Submit
          </vs-button>

          <vs-button
            color="secondary"
            class="font-semibold rounded-full lg:py-3 fsize14 md:py-3 py-2 px-10 sm-fsize14"
            @click="resetFunc()"
          >
            Reset
          </vs-button>
        </div>
        <!-- </el-form> -->
      </el-dialog>

      <div class="flex w-full justify-between">
        <div class="text-left flex justify-between items-center w-full">
          <h2
            class="lg:font-semibold md:font-semibold font-bold lg:text-3xl lg:w-7/12 md:text-3xl text-xl"
          >
            Here’s a brief summary of your project based on your requirements
          </h2>
        </div>
      </div>

      <!-- <div class="flex items-center mt-4">
      <vs-button
        color="secondary"
        class="font-semibold lg:px-16 md:px-16 px-6 fsize14 sm-fsize12 lg:py-5 md:py-5 py-4 rounded-full lg:mr-3 md:mr-3 mr-2"
        >Re-Scope
      </vs-button>
      <vs-button
        :disabled="loungeClicked"
        id="loungeButton"
        class="vs-con-loading__container font-semibold lg:px-16 md:px-16 px-6 fsize14 sm-fsize12 lg:py-5 md:py-5 py-4 rounded-full lg:ml-3 md:ml-3 ml-2"
        >Save Project</vs-button
      >
      </div> -->

      <!-- Table -->
      <el-dialog
        title="Add New Requirement"
        :visible.sync="isShowDraft"
        width="30%"
        center
        :before-close="handleClose"
      >
        <el-form
          role="form"
          class=""
          :model="ruleFormDraft"
          :rules="rules"
          ref="ruleFormDraft"
        >
          <el-form-item prop="logTableName">
            <div>
              <el-input
                placeholder="Add name"
                v-model="ruleFormDraft.logTableName"
                data-vv-validate-on="input|blur"
                @keyup.native.enter="addNewDraft"
              >
              </el-input>
            </div>
          </el-form-item>
          <div class="flex justify-center mt-4">
            <vs-button
              color="primary"
              class="px-6 fsize14 py-2"
              @click="handleSubmit('ruleFormDraft')"
              >Save</vs-button
            >
          </div>
        </el-form>
      </el-dialog>
      <div class="relative">
        <vs-button
          class="absolute right-0 zindex99 top-0 text-dark font-semibold sm-draftbutton px-8"
          color="lightgray"
          @click="isShowDraft = true"
          >Add Draft</vs-button
        >

        <el-tabs class="mt-5" v-model="tabSelected" @tab-click="handleClick">
          <el-tab-pane
            v-for="(a, index) in logsTableData"
            :name="a"
            :key="index"
          >
            <span slot="label"
              >{{ a.name
              }}<i v-if="!a.isFinalize" class="el-icon-edit pl-2"></i>
            </span>

            <i
              v-if="a.isVersionBased && !logsAllData.length"
              class="el-icon-info"
              >No Roles, Pages or User stories exist in this version</i
            >

            <div class="lg:flex gap-8 md:flex mt-6">
              <vx-card
                class="lg:w-1/2 md:w-1/2 rounded20 bg-white shadow-none c-bordert lg:mb-0 md:mb-0 mb-6 p-6"
              >
                <!-- <div class="mb-10 inlinetable">
            <h2
              class="text-303030 fsize20 sm-fsize14 font-semibold lg:mb-6 mb-3"
            >
              Project Suite
            </h2>

            <div class="flex flex-wrap">
              <p
                class="flex items-center fsize14 font-medium sm-fsize12 px-5 py-2 text-warning rounded-full text-center light-chipswarning m-2"
              >
                Project Name
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-5 h-5"
                  class="flex ml-1 cursor-pointer"
                />
              </p>

              <p
                @click="isShowAdd = true"
                class="fsize14 flex cursor-pointer items-center sm-fsize12 px-5 py-2 text-warning rounded-full text-center font-medium light-chipswarning m-2"
              >
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="w-5 h-5"
                  class="flex mr-2"
                />
                Add
              </p>
            </div>
          </div> -->

                <div class="mb-10">
                  <h2
                    class="text-303030 fsize20 sm-fsize14 font-semibold lg:mb-6 mb-3"
                  >
                    User Roles
                  </h2>
                  <div class="flex flex-wrap">
                    <!-- <p
              v-for="(role, index) in selectedID === 2
                ? userSelectedRoles
                : allRoles"
              :key="'role' + index"
              class="fsize14 px-5 py-2 rounded-full text-center m-2"
              :class="[
                role._id
                  ? 'bg-light-primary text-primary'
                  : 'bg-primary text-white',
                role.isRecommendation ? 'bg-secondary' : '',
              ]"
            >
              {{ role.role }}
            </p> -->
                    <div v-for="(i, index) in roleslogsData" :key="index">
                      <p
                        class="flex items-center fsize12 bg-light-primary text-primary px-5 py-2 rounded-full text-center m-2 font-medium"
                      >
                        {{ i.name }}
                        <feather-icon
                          icon="XIcon"
                          v-if="!a.isFinalize"
                          svgClasses="w-5 h-5"
                          class="flex ml-1 cursor-pointer"
                          @click="deleteLogs(i)"
                        />
                      </p>
                    </div>
                    <p
                      @click="isShowAddForRoles = true"
                      v-if="!a.isFinalize"
                      class="fsize12 bg-light-green font-semibold cursor-pointer text-primary px-5 py-2 rounded-full text-center m-2 m-2 flex font-medium items-center"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="w-5 h-5"
                        class="flex mr-2"
                      />
                      Add
                    </p>
                  </div>
                </div>

                <div class="">
                  <h2
                    class="text-303030 fsize20 sm-fsize14 font-semibold lg:mb-6 mb-3"
                  >
                    Website Pages
                  </h2>
                  <div class="flex flex-wrap">
                    <div v-for="(i, index) in pageslogsData" :key="index">
                      <p
                        class="flex items-center fsize12 px-5 py-2 m-2 text-info rounded-full text-center light-chipswarning font-medium"
                      >
                        {{ i.name }}
                        <feather-icon
                          icon="XIcon"
                          v-if="!a.isFinalize"
                          @click="deleteLogs(i)"
                          svgClasses="w-5 h-5"
                          class="flex ml-1 cursor-pointer"
                        />
                      </p>
                    </div>

                    <p
                      @click="isShowAddForPages = true"
                      v-if="!a.isFinalize"
                      class="fsize12 px-5 py-2 m-2 cursor-pointer text-info rounded-full text-center bg-light-green font-semibold flex items-center font-medium"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="w-5 h-5"
                        class="flex mr-2"
                      />
                      Add
                    </p>
                  </div>
                </div>
                <div class="mt-8">
                  <h2
                    class="text-303030 fsize20 sm-fsize14 font-semibold lg:mb-6 mb-3"
                  >
                    Admin Pages
                  </h2>
                  <div class="flex flex-wrap">
                    <div v-for="(i, index) in adminpageslogsData" :key="index">
                      <p
                        class="flex items-center fsize12 px-5 py-2 m-2 text-info rounded-full text-center light-chipswarning font-medium"
                      >
                        {{ i.name }}
                        <feather-icon
                          icon="XIcon"
                          v-if="!a.isFinalize"
                          @click="deleteLogs(i)"
                          svgClasses="w-5 h-5"
                          class="flex ml-1 cursor-pointer"
                        />
                      </p>
                    </div>

                    <p
                      @click="isShowAddForAdminPages = true"
                      v-if="!a.isFinalize"
                      class="fsize12 px-5 py-2 m-2 cursor-pointer text-info rounded-full text-center bg-light-green font-semibold flex items-center font-medium"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="w-5 h-5"
                        class="flex mr-2"
                      />
                      Add
                    </p>
                  </div>
                </div>
              </vx-card>

              <vx-card
                class="lg:w-1/2 md:w-1/2 rounded20 bg-white shadow-none c-bordert px-6 h-full"
              >
                <div class="text-left flex justify-between items-center">
                  <h2 class="font-semibold sm-fsize20 fsize20">User Logs</h2>
                  <vs-button
                    color="primary"
                    v-if="!a.isVersionBased"
                    @click="newScopeCreate(i)"
                    >Generate</vs-button
                  >
                </div>

                <div class="primaryborder-set mt-8 rounded-12px c-scrollreport">
                  <h2
                    class="font-semibold fsize16 bg-f8eef7 hrad-radround text-primary p-4"
                  >
                    Recent Logs
                  </h2>

                  <ul
                    class="scrollbar35 p-1"
                    v-for="(i, index) in logsAllData"
                    :key="index"
                  >
                    <li
                      class="fsiz12 p-3 flex justify-between lightbottom-b cursor-pointer"
                    >
                      <div>
                        <Span>
                          <span v-if="i.isDeleted">Delete- </span
                          ><span v-else>Add- </span>
                        </Span>
                        <span v-if="i.type == 'User Stories'">
                          As a
                          <span class="font-medium text-primary pr-1">{{
                            i.storiesRole
                          }}</span>
                          on
                          <span class="font-medium text-primary pr-1"
                            >{{ i.storiesPage }},
                          </span>
                          <span class="font-medium text-primary pr-1">{{
                            i.description
                          }}</span></span
                        >
                        <span v-else class="font-medium text-primary pr-1">
                          {{ i.name }}</span
                        ><span v-if="i.type == 'Role'">role</span>
                        <span v-else-if="i.type == 'Page'"
                          ><span v-if="i.pageSource == 'Admin'"> admin </span
                          >page</span
                        >
                        <span v-else-if="i.type == 'User Stories'">
                          user story</span
                        >
                      </div>
                      <div v-if="!a.isFinalize">
                        <feather-icon
                          @click="restoreLog(i)"
                          icon="RotateCcwIcon"
                          v-if="i.isDeleted == true"
                          svgClasses="w-4 h-4"
                        />
                      </div>
                    </li>

                    <!-- <li
              class="fsiz12 p-3 flex justify-between lightbottom-b cursor-pointer"
            >
              <div>
                <Span>Akshit deleted </Span>
                <span class="font-medium text-primary pr-1"> Role</span>role
              </div>
              <feather-icon icon="RotateCcwIcon" svgClasses="w-4 h-4" />
            </li>

            <li
              class="fsiz12 p-3 flex justify-between lightbottom-b cursor-pointer"
            >
              <div>
                <Span>Akshit deleted </Span>
                <span class="font-medium text-primary pr-1"> Contact Us</span>
                page
              </div>
              <feather-icon icon="RotateCcwIcon" svgClasses="w-4 h-4" />
            </li> -->
                  </ul>
                </div>
              </vx-card>
            </div>

            <div class="grid grid-cols-2 gap-8">
              <vx-card
                class="mt-0 rounded20 block bg-white c-bordert shadow-none px-6 h-full"
              >
                <div class="text-left">
                  <div class="flex items-center justify-between">
                    <h2 class="font-semibold sm-fsize20 fsize20">
                      User Stories
                    </h2>
                    <p
                      @click="isShowUserAdd = true"
                      v-if="!a.isFinalize"
                      class="fsize12 px-5 py-2 m-2 cursor-pointer text-info rounded-full text-center bg-light-green font-semibold flex items-center font-medium"
                    >
                      <feather-icon
                        icon="PlusIcon"
                        svgClasses="w-5 h-5"
                        class="flex mr-2"
                      />
                      Add
                    </p>
                  </div>
                  <p class="mt-2 fsize16 text-929292 sm-fsize12">
                    Your requirements are translated into userstories that help
                    you identify user roles, Pages & user activities.
                  </p>
                </div>

                <!-- <div class="mt-6 lg:flex items-center gap-3">
            <div class="lg:w-1/2 flex w-full items-center">
              <div class="w-2/12">
                <p class="text-303030 fsize16 items-center font-semibold">
                  As a
                </p>
              </div>
              <div class="w-10/12">
                <select v-model="selectedRole" class="userselect-pad py-2 mx-2">
                  <option>Customer</option>
                </select>
              </div>
            </div>
            <div class="lg:w-1/2 flex w-full lg:mt-0 mt-2 items-center">
              <div class="w-2/12">
                <p class="text-303030 fsize16 items-center font-semibold">On</p>
              </div>
              <div class="w-10/12">
                <select v-model="selectedPage" class="userselect-pad py-2 mx-2">
                  <option>Home</option>
                  <option>About Us</option>
                  <option>Contact Us</option>
                </select>
              </div>
            </div>
          </div> -->

                <div class="primaryborder-set mt-8 rounded-12px c-scrollreport">
                  <!-- <h2
              class="font-semibold fsize16 bg-f8eef7 hrad-radround text-primary p-4"
            >
              The Selected role can...
            </h2> -->

                  <ul class="scrollbar35 p-1" v-if="storieslogsData.length">
                    <div
                      class="flex lightbottom-b items-center px-2"
                      v-for="(i, index) in storieslogsData"
                      :key="index"
                    >
                      <li class="fsiz12 p-3 cursor-pointer">
                        As a/an
                        <span class="font-medium text-primary pr-1">{{
                          i.storiesRole
                        }}</span>
                        on
                        <span class="font-medium text-primary pr-1"
                          >{{ i.storiesPage }}, {{ i.description }}</span
                        >
                      </li>
                      <feather-icon
                        icon="XIcon"
                        v-if="!a.isFinalize"
                        @click="deleteLogs(i)"
                        svgClasses="w-5 h-5"
                        class="flex ml-1 cursor-pointer"
                      />
                    </div>

                    <!-- <li class="fsiz12 p-3 lightbottom-b cursor-pointer">
                I can change Password
              </li>
              <li class="fsiz12 p-3 lightbottom-b cursor-pointer">
                I can Register as New User
              </li> -->
                  </ul>
                </div>
                <div class="flex items-center mt-10 gap-4">
                  <vs-button
                    color="success"
                    v-if="!a.isFinalize"
                    class="py-2 fsize14 px-6"
                    @click="finalizeDraft()"
                    >Save & Submit</vs-button
                  >
                  <!--  v-if="!a.isVersionBased" -->
                  <vs-button
                    color="danger"
                    v-if="!a.isVersionBased"
                    @click="deleteDraft()"
                    class="py-2 fsize14 px-6"
                    >Delete</vs-button
                  >
                </div>
                <!-- v-if="!a.isVersionBased"  -->
              </vx-card>
            </div>
          </el-tab-pane>

          <!-- <el-tab-pane>
            <span slot="label">Route<i class="el-icon-edit pl-2"></i> </span>
          </el-tab-pane> -->
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import Newscope from "./Newscope.vue";
import { mapState } from "vuex";
import jwt from "jsonwebtoken";
import ref from "vue";
import FeatherIcon from "../../../../../components/FeatherIcon.vue";

export default {
  components: { FeatherIcon, Newscope },
  data() {
    return {
      isShowUserAdd: false,
      selectedRole: [],
      selectedPage: [],
      allUserRoles: [{}],
      allPages: [],
      allSuites: [],
      stories: [],
      loungeClicked: false,
      isshowscope: false,
      claim: "",
      Hello_Url: process.env.VUE_APP_BRAINED_API_URL,
      tasklist: "",
      additionalPagesForPercent: "",
      suitePagesForPercent: "",
      isShowAdd: false,
      isShowAddForRoles: false,
      isShowAddForPages: false,
      isShowAddForAdminPages: false,
      input: "",
      addRole: [],
      // addPage: [],
      // addAdminPage: [],
      roleslogsData: [],
      pageslogsData: [],
      adminpageslogsData: [],
      pageForStories: [],
      roleForStories: [],
      storieslogsData: [],
      logsAllData: [],
      // pageRecommends: [],
      // roleRecommends: [],
      addMultipleRole: [],
      addMultiplePage: [],
      addMultipleAdminPage: [],
      currentTasklist: "",
      allVersionAdminPages: [],
      allVersionPages: [],
      allVersionRoles: [],
      addUserStoriesValue: [
        {
          "As a": "",
          On: "",
          Description: "",
        },
      ],
      isShowDraft: false,
      // logTableName: "",
      logsTableData: [],
      tabSelected: "",
      tabForReq: "",
      versions: [],
      rules: {
        logTableName: [
          {
            required: true,
            message: "Please Enter Draft Name",
            trigger: "blur",
          },
        ],
        addRole: [
          {
            required: true,
            message: "Please Enter Role Name",
            trigger: "blur",
          },
        ],
        addPage: [
          {
            required: true,
            message: "Page is required",
            trigger: "blur",
          },
        ],
        addAdminPage: [
          {
            required: true,
            message: "Admin Page is reqiured",
            trigger: "blur",
          },
        ],
        // addUserStoriesValue['As a']: [
        //   {
        //     required: true,
        //     message: "Please Enter Admin Page Name",
        //     trigger: "blur",
        //   },
        // ],
      },
      ruleFormDraft: {
        logTableName: "",
      },
      // ruleFormRoles: {
      //   addRole: [],
      // },
      ruleFormWebPg: {
        addPage: [],
      },
      ruleFormAdPg: {
        addAdminPage: [],
      },
      selectedForm: "",
    };
  },

  methods: {
    async loungeBtn() {
      if (this.selectedPlan.plan.name !== "Free") {
        // yearly
        let duration = 12;
        let price = this.selectedPlan.billing.price * duration;
        let gst = price * 100 * 0.18;
        const { data } = await Axios.post(
          `${this.Hello_Url}brained/payment/create_order`,
          {
            amount: price * 100 + gst,
            currency: "INR",
          }
        );

        const options = {
          // key: process.env.VUE_APP_RAZORPAY_KEY,
          currency: "INR",
          order_id: data.id,
          prefill: {
            email: this.userDetails.email,
          },
          handler: async (response) => {
            await this.successResponse();
          },
        };

        const rzp = await new Razorpay(options);
        rzp.open();
      } else {
        await this.successResponse();
      }
    },
    async successResponse() {
      console.log("clicked");
      this.loungeClicked = true;
      this.$vs.loading({
        container: "#loungeButton",
        scale: 0.45,
      });
      await this.createProject();
      await this.setUserPlans();
      await this.createDefaultVersion();
      await this.addRolesToProject();
      await this.addPagesToProject();
      // await this.addStoriestoProject();
      // // this.startAutoDeploy();
      this.$store.commit("scope/SET_IS_CHECKED_OUT", true);
      let prefill = {
        email: this.userDetails.email,
        name: this.userDetails.username,
        plan: this.selectedPlan.plan.name,
        projectName: this.userDetails.projectName,
      };
      const { data } = await Axios.post(
        `${this.Hello_Url}brained/send/paymentEmail`,
        prefill
      );
      this.$store.commit("scope/SET_PROJECT_NAME", "");
      this.$store.commit("scope/SET_FLAG", "");
      setTimeout(() => {
        this.$vs.loading.close("#loungeButton > .con-vs-loading");
        this.loungeClicked = false;
      }, 3000);
      this.$router.push({ name: "ProjectManagement" });

      // this.$router.push({ name: "lounge-page" });
    },
    async addRolesToProject() {
      let payload = {
        addRoles: this.allUserRoles,
        projectId: this.userDetails.projects[0]._id,
        projectName: this.userDetails.projects[0].projectName,
        taskListID: this.tasklist._id,
      };
      await this.$store.dispatch("builder/addRolesToProject", payload);
    },
    async addPagesToProject() {
      let payload = {
        addPages: this.allPages,
        projectId: this.userDetails.projects[0]._id,
        projectName: this.userDetails.projects[0].projectName,
        taskListID: this.tasklist._id,
      };
      await this.$store.dispatch("builder/addPagesToProject", payload);
    },
    async setUserPlans() {
      let payload = {
        projectName: this.projectName.trim().replace(/ /g, "-").toLowerCase(),
        projectId: this.userDetails.projects[0]._id,
        subscription: this.selectedPlan.plan._id,
        plan: this.selectedPlan.billing,
        payment_status: "Paid",
        manHours: `${this.selectedPlan.billing.boosters}`,
      };
      await this.$store.dispatch("billing/addBilling", payload);
    },
    async createDefaultVersion() {
      const payload = {
        projectId: this.userDetails.projects[0]._id,
      };
      let { data } = await this.$store.dispatch(
        "builder/defaultProjectVersion",
        payload
      );
      console.log(data, "datain tas");
      this.tasklist = data;

      console.log(this.tasklist, "TAS");
    },
    async createProject() {
      this.$vs.loading();
      if (!this.userDetails.projects.length) {
        this.authCheck();
        const addPayload = {
          userID: this.userDetails._id,
          projectName: this.projectName,
          displayName: this.projectName,
          businessName: this.projectName,
          mobile: this.claim.userMobile,
          location: "singapore",
          adminLink: this.projectName.trim().replace(/ /g, "-").toLowerCase(),
          source: this.offerActivated
            ? "Reseller Offer"
            : this.resellerLead
            ? "Reseller"
            : "Website",
          discountPercentage: this.discountPercentage,
          discountName: this.discountName,
        };

        await this.$store.dispatch("scope/createProject", addPayload);

        await this.setUserSuites();

        const userData = {
          email: this.userDetails.email.toLowerCase(),
        };
        const { data } = await Axios.post(
          `${this.Hello_Url}brained/user/viewUser`,
          userData
        );
        console.log(data);
        const userD = { ...data.result.projects[0], ...data.result };

        this.$store.commit("scope/SET_TOKEN", data.token);
        this.$store.commit("scope/SET_USER_DETAILS", userD);
        localStorage.setItem("token", data.token);
      }

      if (this.userDetails.projects.length) {
        const payload = {
          mobile: this.claim.userMobile,
          projectName: this.projectName,
        };
        await Axios.post(
          `${this.Hello_Url}brained/user/addScopeRequirements`,
          payload
        );
        this.$vs.loading.close();
      }
    },
    async setUserSuites() {
      this.$vs.loading();
      let suitesData = [];

      this.suites.forEach((item) => {
        let obj = {
          _id: item._id,
          img: item.suiteImage,
          title: item.name,
          selectStatus: false,
          keywords: item.keywords,
          type: item.type,
        };
        suitesData.push(obj);
      });

      const payload = {
        mobile: this.claim.userMobile,
        suites: suitesData,
      };
      await Axios.post(
        `${this.Hello_Url}brained/user/addScopeRequirements`,
        payload
      );
      this.$vs.loading.close();
    },
    async getStories() {
      if (Object.keys(this.selectedPage).length > 0) {
        let Payload = {
          pages: [this.selectedPage._id],
          roles: [this.selectedRole._id],
          story: true,
        };
        let data = await this.$store.dispatch("scope/getStories", Payload);
        this.stories = data.data.data;
      }
    },
    reScope() {
      this.$router.push({ name: "scope-Requirements" });
    },
    async filterPages() {
      let feature = [];
      let demo = [];
      for (let i = 0; i < this.selectedSuiteData.length; i++) {
        if (this.selectedSuiteData[i].pages)
          feature.push(this.selectedSuiteData[i].pages);
      }
      for (let i = 0; i < feature.length; i++) {
        demo = demo.concat(feature[i]);
      }
      let temp = await this.filterDuplicates(demo);
      this.allPages = temp.concat(this.allPages);
      this.allPages = await this.filterDuplicates(this.allPages);

      this.selectedPage = this.allPages[0];
    },
    async filterUserRoles() {
      let feature = [];
      let demo = [];
      for (let i = 0; i < this.selectedSuiteData.length; i++) {
        if (this.selectedSuiteData[i].roles)
          feature.push(this.selectedSuiteData[i].roles);
      }
      for (let i = 0; i < feature.length; i++) {
        demo = demo.concat(feature[i]);
      }
      let temp = await this.filterDuplicates(demo);
      this.allUserRoles = temp.concat(this.allUserRoles);
      this.allUserRoles = await this.filterDuplicates(this.allUserRoles);
      this.selectedRole = this.allUserRoles[0];

      await Axios.post(
        `${this.Hello_Url}brained/user/addScopeRequirements`,
        this.allUserRoles
      );
    },
    // for speech to text sentence which gave roles  and pages from gpt
    DivideRecomendation() {
      for (let i = 0; i < this.recommendations.length; i++) {
        if (this.recommendations[i].types == "Roles") {
          this.allUserRoles.push(this.recommendations[i]);
        } else if (this.recommendations[i].types == "PAGES") {
          this.allPages.push(this.recommendations[i]);
        }
      }
    },
    async recommendationPagesFilter() {
      let unfilterPages = this.allPages;
      const uniquenames = {};
      const uniqueObjects = [];
      for (const obj of unfilterPages) {
        if (!uniquenames[obj.page]) {
          uniquenames[obj.page] = true;
          uniqueObjects.push(obj);
        }
      }
      this.allPages = uniqueObjects;
    },
    async recommendationRolesFilter() {
      let unfilterRoles = this.allUserRoles;
      const uniquenames = {};
      const uniqueObjects = [];
      for (const obj of unfilterRoles) {
        if (!uniquenames[obj.role]) {
          uniquenames[obj.role] = true;
          uniqueObjects.push(obj);
        }
      }
      this.allUserRoles = uniqueObjects;
    },

    // give array set ,just pass array
    filterDuplicates(arr) {
      const uniqueSet = new Set(arr.map((item) => JSON.stringify(item)));
      return Array.from(uniqueSet).map((item) => JSON.parse(item));
    },
    authCheck() {
      const token1 = localStorage.getItem("token");
      if (token1) {
        this.claim = jwt.verify(
          token1,
          "TWFnaXR0IENvbnN1bHRhbmN5IHNlcnZlcyBidXNpbmVzc2VzIGluIGFsbCBtYWpvciBzZWN0b3JzLHByb3ZpZGluZyBleGNlcHRpb25hbCBzb2Z0d2FyZSBzb2x1dGlvbnMgZm9yIGxhcmdlIGNvcnBvcmF0aW9ucyxtaWQtc2l6ZWQgZW50ZXJwcmlzZXMsYW5kIHN0YXJ0dXAuundefined"
        );
      }
      console.log(this.claim);
      // if (this.claim) {
      // login not used anywhere
      //   this.loginactive = false;
      // }
    },
    async addDesp() {
      await this.getPagesLogs();
      await this.getRolesLogs();
      console.log("add fileds called");
      this.addUserStoriesValue.push({
        "As a": "",
        On: "",
        Description: "",
      });
    },
    async addDefaultPages() {
      let defaultPages = await this.$store.dispatch("builder/getDefaultPages");
      this.$store.commit("scope/SET_DEFAULT_PAGES", defaultPages.data.data);
    },
    async urlFlag() {
      let flag = {
        mobile: this.claim.userMobile,
        flag: "summary-report",
      };
      await Axios.post(`${this.Hello_Url}brained/user/userFlag`, flag);

      this.$store.commit("scope/SET_FLAG", flag.flag);
    },
    async getTasklist() {
      let tasklist = await this.$store.dispatch("builder/getTasklist", {
        projectName: this.selectedProject.projectName,
      });
      for (let i = 0; i < tasklist.data.length; i++) {
        this.currentTasklist = tasklist.data[tasklist.data.length - 1];
      }
    },
    // logs func
    // done
    async getRolesLogsData() {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        isDeleted: false,
        isRejected: false,
        isApproved: false,
        type: "Role",
      };

      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      this.roleslogsData = data;
    },
    // done
    async getPagesLogsData() {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        isDeleted: false,
        isApproved: false,
        isRejected: false,
        type: "Page",
        pageSource: "Website",
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      this.pageslogsData = data;
    },
    // done
    async getAdminPagesLogsData() {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        isDeleted: false,
        isApproved: false,
        isRejected: false,
        type: "Page",
        pageSource: "Admin",
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      this.adminpageslogsData = data;
    },

    async getPagesLogs() {
      let payload = {
        // tasklistID: this.selectedSprint._id,
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        type: "Page",
        isDeleted: false,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      console.log(data, "pageForStories");

      this.pageForStories = data;
    },
    async getRolesLogs() {
      let payload = {
        // tasklistID: this.selectedSprint._id,
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        type: "Role",
        isDeleted: false,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      console.log(data, "roleForStories");
      this.roleForStories = data;
    },
    async getStoriesLogsData() {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        isDeleted: false,
        isApproved: false,
        isRejected: false,
        type: "User Stories",
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      this.storieslogsData = data;
    },
    // done
    async getAllLogsData() {
      let payload = {
        projectName: this.selectedProject.projectName,
        isApproved: false,
        logDraftName: this.tabSelected._id,
        isRejected: false,
      };
      const data = await this.$store.dispatch(
        "logsForPagesRoles/getLogsDetails",
        payload
      );
      this.logsAllData = data.data;
    },
    // done
    async addLogsData() {
      if (this.addMultipleRole.length) {
        for (let i in this.addMultipleRole) {
          let payload = {
            projectName: this.selectedProject.projectName,
            source: "Admin",
            logDraftName: this.tabSelected._id,
            name: this.addMultipleRole[i],
            type: "Role",
            isNewLog: true,
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
        }
      }
      if (this.addMultiplePage.length) {
        for (let i in this.addMultiplePage) {
          let payload = {
            projectName: this.selectedProject.projectName,
            source: "Admin",
            pageSource: "Website",
            logDraftName: this.tabSelected._id,
            name: this.addMultiplePage[i],
            type: "Page",
            isNewLog: true,
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
        }
      }
      if (this.addMultipleAdminPage.length) {
        for (let i in this.addMultipleAdminPage) {
          let payload = {
            projectName: this.selectedProject.projectName,
            source: "Admin",
            pageSource: "Admin",
            logDraftName: this.tabSelected._id,
            name: this.addMultipleAdminPage[i],
            type: "Page",
            isNewLog: true,
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
        }
      }
      if (this.addRole.length) {
        let newRoles = this.addRole.split(",");
        newRoles.forEach(async (x) => {
          this.$validator.validateAll().then(async (result) => {
            if (result) {
              let payload = {
                projectName: this.selectedProject.projectName,
                source: "Admin",
                logDraftName: this.tabSelected._id,
                isNewLog: true,
              };
              // if (this.ruleFormRoles.addRole) {
              // Object.assign(payload, { name: this.ruleFormRoles.addRole });
              Object.assign(payload, { name: x });
              Object.assign(payload, { type: "Role" });
              // }
              const { data } = await this.$store.dispatch(
                "logsForPagesRoles/addLogsDetails",
                payload
              );
              // await this.handleClose();
              await this.getRolesLogsData();
              // await this.getPagesLogsData();
              // await this.getAdminPagesLogsData();
              // await this.getAllLogsData();
              // this.$validator.reset();
              // this.errors.clear();
            }
          });
        });
      }
      if (this.ruleFormWebPg.addPage.length) {
        let newPages = this.ruleFormWebPg.addPage.split(",");
        newPages.forEach(async (x) => {
          // this.$validator.validateAll().then(async (result) => {
          //   if (result) {
          let payload = {
            projectName: this.selectedProject.projectName,
            source: "Admin",
            logDraftName: this.tabSelected._id,
            isNewLog: true,
          };
          // if (this.ruleFormWebPg.addPage) {
          //   Object.assign(payload, { name: this.ruleFormWebPg.addPage });
          Object.assign(payload, { name: x });
          Object.assign(payload, { type: "Page" });
          Object.assign(payload, { pageSource: "Website" });
          // }
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
          //  await this.handleClose();
          // await this.getRolesLogsData();
          await this.getPagesLogsData();
          // await this.getAdminPagesLogsData();
          await this.getAllLogsData();
          // this.$validator.reset();
          // this.errors.clear();
          //   }
          // });
        });
      }
      if (this.ruleFormAdPg.addAdminPage.length) {
        let newAdminPages = this.ruleFormAdPg.addAdminPage.split(",");
        newAdminPages.forEach(async (x) => {
          // this.$validator.validateAll().then(async (result) => {
          //   if (result) {
          let payload = {
            projectName: this.selectedProject.projectName,
            logDraftName: this.tabSelected._id,
            source: "Admin",
            isNewLog: true,
          };
          // if (this.ruleFormAdPg.addAdminPage) {
          //   Object.assign(payload, { name: this.ruleFormAdPg.addAdminPage });
          Object.assign(payload, { name: x });
          Object.assign(payload, { type: "Page" });
          Object.assign(payload, { pageSource: "Admin" });
          // }
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/addLogsDetails",
            payload
          );
          // await this.handleClose();
          // await this.getRolesLogsData();
          // await this.getPagesLogsData();
          await this.getAdminPagesLogsData();
          await this.getAllLogsData();
          // this.$validator.reset();
          // this.errors.clear();
          //   }
          // });
        });
      }
      await this.handleClose();
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
      await this.getAllLogsData();
      this.$validator.reset();
      this.errors.clear();
    },
    async getAll() {
      await this.handleClose();
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
      await this.getAllLogsData();
    },
    async handleClose() {
      await this.resetFunc();
      this.isShowAddForPages = false;
      this.isShowAddForRoles = false;
      this.isShowAddForAdminPages = false;
      this.isShowUserAdd = false;
      this.isShowDraft = false;
    },
    async handleClose2() {
      this.isshowscope = false;
      // this.getTasklist();
      await this.getAllLogsData();
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
    },
    async closePopupFunc(params) {
      this.isshowscope = false;
      // this.getTasklist();
      await this.getAllLogsData();
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
    },
    // done
    async deleteLogs(value) {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        _id: value._id,
        isDeleted: true,
        isNewLog: true,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/deleteLogsDetails",
        payload
      );
      await this.getRolesLogsData();
      await this.getStoriesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
      await this.getAllLogsData();
    },
    // done
    async restoreLog(value) {
      let payload = {
        projectName: this.selectedProject.projectName,
        logDraftName: this.tabSelected._id,
        _id: value._id,
        isDeleted: false,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/editLogsDetails",
        payload
      );
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAllLogsData();
    },
    async addPageRecommendations() {
      let recommendations = await Axios.post(
        process.env.VUE_APP_API_BUILDER + "/Recommendation_v1",
        {
          string: `All possible pages in an ecommerce suite in a array format`,
        }
      );
      // this.pageRecommends = recommendations.data;
      this.$store.commit(
        "logsForPagesRoles/PAGES_RECOMMENDS",
        recommendations.data
      );
      console.log(this.pagesRecommends, "PAGESS");
    },
    async addRoleRecommendations() {
      let recommendations = await Axios.post(
        process.env.VUE_APP_API_BUILDER + "/Recommendation_v1",
        {
          string:
            `All possible role in an ` +
            this.selectedProject.suites[0].title +
            ` suite in a array format`,
        }
      );
      // this.roleRecommends = recommendations.data;
      this.$store.commit(
        "logsForPagesRoles/ROLES_RECOMMENDS",
        recommendations.data
      );
      console.log(this.rolesRecommends, "ROLESS");
    },
    async addRoleFromRecommends(value) {
      this.addMultipleRole.push(value);
    },
    async removeRoleFromRecommends(value) {
      this.addMultipleRole.pop(value);
    },
    async addPageFromRecommends(value) {
      this.addMultiplePage.push(value);
    },
    async addAdminPageFromRecommends(value) {
      this.addMultipleAdminPage.push(value);
    },
    handleBack() {
      this.$router.push({ name: "builder" });
    },
    async getAllRoles() {
      // let payload = {
      //   tasklistID: this.selectedSprint._id,
      //   projectName: this.selectedProject.projectName,
      //   isDeleted: false,
      // };
      // const { data } = await this.$store.dispatch(
      //   "logsForPagesRoles/getLogsTable",
      //   payload
      // );
      // console.log(data, "log table");
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        tasklistID: this.selectedSprint._id,
      };
      let data = await this.$store.dispatch("builder/getRoles", payload);
      // for (let i = 0; i < data.length; i++) {
      //   // this.allVersionRoles.push(data[i].name);
      //   let payload = {
      //     tasklistID: this.selectedSprint._id,
      //     projectName: this.selectedProject.projectName,
      //     source: "Admin",
      //     logDraftName: data1[0]._id,
      //     // action: "Add",
      //     name: data[i].name,
      //     type: "Role",
      //     isNewLog: true,
      //   };
      //   const { data } = await this.$store.dispatch(
      //     "logsForPagesRoles/addLogsDetails",
      //     payload
      //   );
      // }

      // for (let i = 0; i < this.allVersionRoles.length; i++) {
      //   let payload = {
      //     tasklistID: this.selectedSprint._id,
      //     projectName: this.selectedProject.projectName,
      //     source: "Admin",
      //     logDraftName: this.tabSelected,
      //     // action: "Add",
      //     name: this.allVersionRoles[i],
      //     type: "Role",
      //     isNewLog: true,
      //   };
      //   const { data } = await this.$store.dispatch(
      //     "logsForPagesRoles/addLogsDetails",
      //     payload
      //   );
      // }

      // this.allVersionRoles = data;
    },
    async getAllPages() {
      let payload1 = {
        tasklistID: this.selectedSprint._id,
        projectName: this.selectedProject.projectName,
        isDeleted: false,
      };
      const { data1 } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsTable",
        payload1
      );
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        tasklistID: this.selectedSprint._id,
        type: "Website",
      };
      let { data } = await this.$store.dispatch("builder/getPages", payload);
      for (let i = 0; i < data.length; i++) {
        // this.allVersionPages.push(data[i].name);
        let payload = {
          tasklistID: this.selectedSprint._id,
          projectName: this.selectedProject.projectName,
          source: "Admin",
          pageSource: "Website",
          logDraftName: data1[0]._id,
          name: data[i].name,
          type: "Page",
          isNewLog: true,
        };
        const { data } = await this.$store.dispatch(
          "logsForPagesRoles/addLogsDetails",
          payload
        );
      }
      // for (let i = 0; i < this.allVersionPages.length; i++) {
      //   let payload = {
      //     tasklistID: this.selectedSprint._id,
      //     projectName: this.selectedProject.projectName,
      //     source: "Admin",
      //     pageSource: "Website",
      //     logDraftName: this.tabSelected,
      //     name: this.allVersionPages[i],
      //     type: "Page",
      //     isNewLog: true,
      //   };
      //   const { data } = await this.$store.dispatch(
      //     "logsForPagesRoles/addLogsDetails",
      //     payload
      //   );
      // }

      // this.allVersionPages = data;
    },
    async getAllAdminPages() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        tasklistID: this.selectedSprint._id,
        type: "Admin",
      };
      let { data } = await this.$store.dispatch("builder/getPages", payload);
      for (let i = 0; i < data.length; i++) {
        this.allVersionAdminPages.push(data[i].name);
      }
      // this.allVersionAdminPages = data;
    },
    async addStoriesFunc() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          for (let i = 0; i < this.addUserStoriesValue.length; i++) {
            let payload = {
              tasklistID: this.selectedSprint._id,
              projectName: this.selectedProject.projectName,
              source: "Admin",
              logDraftName: this.tabSelected,
              description: this.addUserStoriesValue[i].Description,
              storiesPage: this.addUserStoriesValue[i].On,
              storiesRole: this.addUserStoriesValue[i]["As a"],
              type: "User Stories",
              isNewLog: true,
            };
            const { data } = await this.$store.dispatch(
              "logsForPagesRoles/addLogsDetails",
              payload
            );
          }
          await this.getAllLogsData();
          await this.getStoriesLogsData();
          this.isShowUserAdd = false;
          this.addUserStoriesValue = [];
          this.addUserStoriesValue.push({
            "As a": "",
            On: "",
            Description: "",
          });
          this.$validator.reset();
          this.errors.clear();
        }
      });
    },
    resetFunc() {
      if (this.$refs[this.selectedForm]) {
        this.$refs[this.selectedForm].resetFields();
      }
      if (this.isShowUserAdd) {
        this.$validator.reset();
        this.errors.clear();
        this.addUserStoriesValue = [];
        this.addUserStoriesValue.push({
          "As a": "",
          On: "",
          Description: "",
        });
      }
      if (this.isShowAddForRoles) {
        this.$validator.reset();
        this.errors.clear();
        this.addRole = [];
        this.addMultipleRole = [];
      }
      if (this.isShowAddForPages) {
        // this.$validator.reset();
        // this.errors.clear();
        this.ruleFormWebPg.addPage = [];
        this.addMultiplePage = [];
      }
      if (this.isShowAddForAdminPages) {
        // this.$validator.reset();
        // this.errors.clear();
        this.ruleFormAdPg.addAdminPage = [];
        this.addMultipleAdminPage = [];
      }
      if (this.isShowDraft) {
        this.ruleFormDraft.logTableName = "";
      }
      this.selectedForm = "";
    },
    async versionLogTable() {
      const { data } = await this.$store.dispatch("builder/getTasklist", {
        projectName: process.env.VUE_APP_COMMUNITY_NAME,
      });
      this.versions = data;
      console.log(data, "versions");
    },
    async getLogTable() {
      let payload = {
        projectName: this.selectedProject.projectName,
        isDeleted: false,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/getLogsTable",
        payload
      );

      if (data.length) {
        console.log(data, "draft ");
        // for (let i = 0; i < data.length; i++) {
        //   this.tabSelected = data[length - 1];
        // }
        this.logsTableData = data.map((x) => {
          return { ...x, name: x.logTableName };
        });
        // for (let i = 0; i < data.length; i++) {
        //   this.tabSelected = data[data.length - 1];
        //   // this.tabSelected = ref(data[data.length - 1]);
        //   console.log(this.tabSelected, "default selected");
        // }
        for (let i = 0; i < this.logsTableData.length; i++) {
          this.tabSelected = this.logsTableData[this.logsTableData.length - 1];

          console.log(this.tabSelected, "default selected");
        }
        // await this.handleClick(this.tabSelected);
      }
      // else {
      // for (let i = 0; i < this.versions.length; i++){
      //   let payload = {
      //     tasklistID: this.versions[i]._id,
      //     projectName: this.selectedProject.projectName,
      //     logTableName: this.versions[i].name,
      //   };
      //   const { data } = await this.$store.dispatch(
      //     "logsForPagesRoles/addLogsTable",
      //     payload
      //   );
      //   console.log(data, "added");
      // }
      //   let payload = {
      //     tasklistID: this.selectedSprint._id,
      //     projectName: this.selectedProject.projectName,
      //     logTableName: "Default",
      //   };
      //   const { data } = await this.$store.dispatch(
      //     "logsForPagesRoles/addLogsTable",
      //     payload
      //   );
      //   console.log(data, "added");

      //   let payload1 = {
      //     projectId: this.selectedProject._id,
      //     projectName: this.selectedProject.projectName,
      //     tasklistID: this.selectedSprint._id,
      //   };
      //   //role
      //   let data1 = await this.$store.dispatch("builder/getRoles", payload1);
      //   for (let i = 0; i < data1.length; i++) {
      //     // this.allVersionRoles.push(data[i].name);
      //     let payload2 = {
      //       tasklistID: this.selectedSprint._id,
      //       projectName: this.selectedProject.projectName,
      //       source: "Admin",
      //       logDraftName: data._id,
      //       // action: "Add",
      //       name: data1[i].name,
      //       type: "Role",
      //     };
      //     const { data2 } = await this.$store.dispatch(
      //       "logsForPagesRoles/addLogsDetails",
      //       payload2
      //     );
      //   }
      //   // page
      //   let payload3 = {
      //     projectId: this.selectedProject._id,
      //     projectName: this.selectedProject.projectName,
      //     tasklistID: this.selectedSprint._id,
      //     type: "Website",
      //   };
      //   const data3 = await this.$store.dispatch("builder/getPages", payload3);
      //   console.log(data3, "pagesss");
      //   for (let i = 0; i < data3.data.length; i++) {
      //     // this.allVersionPages.push(data[i].name);
      //     let payload4 = {
      //       tasklistID: this.selectedSprint._id,
      //       projectName: this.selectedProject.projectName,
      //       source: "Admin",
      //       pageSource: "Website",
      //       logDraftName: data._id,
      //       name: data3.data[i].name,
      //       type: "Page",
      //     };
      //     const { data4 } = await this.$store.dispatch(
      //       "logsForPagesRoles/addLogsDetails",
      //       payload4
      //     );
      //   }
      //   await this.getLogTable();
      // }
    },
    handleClick(tab, event) {
      console.log(tab.name, event, "event");
    },
    popup() {
      this.$swal({
        text: "New Draft added succesfully",
        icon: "success",
        confirmButtonColor: "#830c81",
        // cancelButtonColor: "#d33",
        confirmButtonText: "Okay",
      });
    },
    // done
    handleSubmit(formName) {
      console.log(formName, "FORM");
      this.selectedForm = formName;
      this.ruleFormDraft.logTableName = this.ruleFormDraft.logTableName.trim();
      if (this.ruleFormWebPg.addPage.length) {
        let newArray = this.ruleFormWebPg.addPage.split(",");
        this.ruleFormWebPg.addPage = newArray[0].trim();
        console.log(this.ruleFormWebPg.addPage, "this.ruleFormWebPg.addPage");
      }
      if (this.ruleFormAdPg.addAdminPage.length) {
        let newArray1 = this.ruleFormAdPg.addAdminPage.split(",");
        this.ruleFormAdPg.addAdminPage = newArray1[0].trim();
        console.log(
          this.ruleFormAdPg.addAdminPage,
          "this.ruleFormAdPg.addAdminPage"
        );
      }

      if (formName === "ruleFormDraft") {
        console.log(formName, "THIS FORM");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addNewDraft();
            if (this.$refs[formName]) {
              this.$refs[formName].resetFields();
            }
          } else {
            return false;
          }
        });
      }

      // else if (formName == "ruleFormRoles") {
      //   this.$refs[formName].validate((valid) => {
      //     if (valid) {
      //       this.addLogsData();
      //       if (this.$refs[formName]) {
      //         this.$refs[formName].resetFields();
      //       }
      //     } else {
      //       return false;
      //     }
      //   });
      // }
      else if (formName == "ruleFormWebPg") {
        console.log(formName, "Web pg called");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addLogsData();
            if (this.$refs[formName]) {
              console.log(formName, "Web pg called");
              this.$refs[formName].resetFields();
            }
          } else {
            return false;
          }
        });
      } else if (formName == "ruleFormAdPg") {
        console.log(formName, "ad pg called");
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addLogsData();
            if (this.$refs[formName]) {
              console.log(formName, "ad pg called");
              this.$refs[formName].resetFields();
            }
          } else {
            return false;
          }
        });
      }
    },
    async addNewDraft() {
      let payload = {
        projectName: this.selectedProject.projectName,
        logTableName: this.ruleFormDraft.logTableName,
      };
      const { data } = await this.$store.dispatch(
        "logsForPagesRoles/addLogsTable",
        payload
      );

      this.popup();
      await this.getLogTable();
      this.isShowDraft = false;
    },
    // Done
    async finalizeDraft() {
      this.$swal
        .fire({
          title: "Alert",
          text: `Are you sure you want to finalize your Draft ?`,
          icon: "warning",
          confirmButtonText: "Yes, Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#EA4Dff",
          cancelButtonColor: "  #6e7881",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            let payload = {
              projectName: this.selectedProject.projectName,
              _id: this.tabSelected._id,
              isFinalize: true,
            };
            const { data } = await this.$store.dispatch(
              "logsForPagesRoles/editLogsTable",
              payload
            );
          }
          await this.getLogTable();
          this.$swal({
            text: "Draft finalized succesfully",
            icon: "success",
            confirmButtonColor: "#830c81",
            confirmButtonText: "Okay",
          });
        });
    },
    // Done
    async deleteDraft() {
      this.$swal
        .fire({
          title: "Alert",
          text: `Are you sure you want to delete your Finalized Draft ?`,
          icon: "warning",
          confirmButtonText: "Yes, Continue",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#EA4Dff",
          cancelButtonColor: "  #6e7881",
        })
        .then(async (result) => {
          let payload = {
            tasklistID: this.selectedSprint._id,
            projectName: this.selectedProject.projectName,
            _id: this.tabSelected._id,
            isDeleted: true,
          };
          const { data } = await this.$store.dispatch(
            "logsForPagesRoles/deleteLogsTable",
            payload
          );
          await this.getLogTable();
          this.$swal({
            text: "Final Draft deleted succesfully",
            icon: "success",
            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
        });
    },
    async newScopeCreate(value) {
      this.tabForReq = value;
      this.isshowscope = true;
    },
  },

  computed: {
    ...mapState("scope", [
      "suites",
      "recommendations",
      "selectedSuiteData",
      "selectedPlan",
      "userDetails",
      "projectName",
      "resellerLead",
      "completePercentage",
      "offerActivated",
      "discountName",
      "discountPercentage",
    ]),
    ...mapState("design", ["selectedSprint"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("logsForPagesRoles", ["rolesRecommends", "pagesRecommends"]),
    async completed() {
      let percent = 95;
      if (this.additionalPagesForPercent == 0) {
        percent = 95;
      } else if (
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100 ===
        100
      ) {
        percent = 95;
      } else if (
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100 <
        28
      ) {
        percent = 28;
      } else {
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100;
      }
      this.$store.commit("scope/SET_PERCENTAGE", parseInt(percent));
      let payload = {
        mobile: this.claim.userMobile,
        completePercentage: percent,
      };
      Axios.post(`${this.Hello_Url}brained/user/addScopeRequirements`, payload);
      return parseInt(percent);
    },
  },
  async mounted() {
    await this.getLogTable();
    await this.versionLogTable();

    // await this.getRolesLogsData();
    // await this.getPagesLogsData();
    // await this.getAdminPagesLogsData();
    // await this.getStoriesLogsData();
    // await this.getPagesLogs();
    // await this.getRolesLogs();
    // await this.getAllLogsData();

    // if (!this.rolesRecommends.length) {
    //   console.log("role called");
    //   await this.addRoleRecommendations();
    // }
    // if (!this.pagesRecommends.length) {
    //   console.log("page called");
    //   await this.addPageRecommendations();
    // }

    // this.allSuites = this.suites;
    // await this.authCheck();
    // await this.DivideRecomendation();
    // this.additionalPagesForPercent = this.allPages.length;
    // await this.filterUserRoles();
    // await this.filterPages();
    // this.suitePagesForPercent =
    //   this.allPages.length - this.additionalPagesForPercent;
    // await this.recommendationPagesFilter();
    // await this.recommendationRolesFilter();
    // await this.addDefaultPages();
    // await this.urlFlag();
  },
  watch: {
    async selectedPage(newval) {
      await this.getStories();
    },
    async selectedRole(newval) {
      await this.getStories();
    },
    async tabSelected() {
      console.log(this.tabSelected, "tabselected");
      await this.getAllLogsData();
      await this.getRolesLogsData();
      await this.getPagesLogsData();
      await this.getAdminPagesLogsData();
      await this.getStoriesLogsData();
      await this.getPagesLogs();
      await this.getRolesLogs();
    },
    async isShowUserAdd(value) {
      await this.getPagesLogs();
      await this.getRolesLogs();
    },
  },
};
</script>
<style>
.vuesax-app-is-ltr .vs-chip--text {
  margin-left: 0px !important;
}
.vs-input--placeholder.normal {
  padding: 13px !important;
}
border-card {
  border-style: solid;
  border-color: #830c81;
  border-width: 4px;
}

.cust-builder-swiper {
  width: 119px;
}
</style>
